import { hasOwnProp } from './utils';

export enum RoutePathName {
    documents = 'documents',
    login = 'login',
    reset = 'reset',
    home = 'home',
    notFound = 'notFound',
    users = 'users',
    sections = 'sections',
}

export type Routes = {
    [r in RoutePathName]: string;
};

export const routes: Routes = {
    [RoutePathName.documents]: '/documents/:section?/:year?',
    [RoutePathName.home]: '/',
    [RoutePathName.users]: '/users',
    [RoutePathName.sections]: '/sections',
    [RoutePathName.login]: '/login',
    [RoutePathName.reset]: '/reset/:token?',
    [RoutePathName.notFound]: '/404',
};

export interface RouteParams {
    [param: string]: string | number;
}

// returns raw react-router string path
export const getRawRoute = (path: RoutePathName) => {
    if (!hasOwnProp(routes, path)) {
        console.error(`[getRawRoute] Route not found for path "${path}", returning /404.`);
        return '/404';
    } else {
        return routes[path];
    }
};
// returns real-world path
export const getRoute = (
    path: RoutePathName,
    params?: RouteParams,
    queryParams?: string | string[][] | Record<string, string> | URLSearchParams | undefined,
) => {
    let route = getRawRoute(path);
    const rawParams = route.split('/').filter((str) => str.startsWith(':'));
    const providedParamNames = params ? Object.keys(params) : [];
    rawParams.forEach((rawParam) => {
        const isOptionnal = rawParam.endsWith('?');
        const rawParamStripped = isOptionnal ?
            rawParam.substring(1, rawParam.length - 1) :
            rawParam.substring(1);
        if (params && providedParamNames.includes(rawParamStripped)) {
            route = route.replace(rawParam, `${params[rawParamStripped]}`);
        } else if (isOptionnal) {
            route = route.replace(`/${rawParam}`, '');
        } else {
            console.info(`[getRoute] Param "${rawParamStripped}" not provided in route "${route}", skipping param.`);
        }
    });
    if (queryParams && Object.keys(queryParams).length) {
        const urlQueryParams = new URLSearchParams(queryParams);
        route += `?${urlQueryParams.toString()}`;
    }
    return route;
};
